module.exports = __webpack_public_path__ + "static/ApercuPro-Light-704bed283dd74abf85ba3d0113c0cd44.woff2";